import { api } from '../client';
import type { User } from '../types';

export const sessionApi = {
  /** GET /api/session — retorna o usuário se houver cookie válido, 404 se não */
  current: () => api.get<User>('/session'),

  /** POST /api/session — login com email e senha (form-encoded) */
  login: (email: string, password: string) =>
    api.post<User>('/session', { form: { email, password } }),

  /** DELETE /api/session — encerra a sessão */
  logout: () => api.delete<void>('/session'),
};
